<div class="audit-execution-answer">
  @switch (item().item_type) {
    @case ('yes_no') {
      <div class="audit-execution-answer__choice-grid audit-execution-answer__choice-grid--compact">
        <button
          class="audit-execution-answer__choice app-choice--semantic"
          [attr.data-tone]="booleanTone(true)"
          [class.audit-execution-answer__choice--selected]="booleanValue() === true"
          type="button"
          [disabled]="readOnly()"
          [attr.aria-pressed]="booleanValue() === true"
          (click)="selectBoolean(true)"
        >
          <span class="fa-solid fa-check" aria-hidden="true"></span>
          {{ i18n.t('auditExecution.answers.yes') }}
        </button>
        <button
          class="audit-execution-answer__choice app-choice--semantic"
          [attr.data-tone]="booleanTone(false)"
          [class.audit-execution-answer__choice--selected]="booleanValue() === false"
          type="button"
          [disabled]="readOnly()"
          [attr.aria-pressed]="booleanValue() === false"
          (click)="selectBoolean(false)"
        >
          <span class="fa-solid fa-xmark" aria-hidden="true"></span>
          {{ i18n.t('auditExecution.answers.no') }}
        </button>
      </div>
    }
    @case ('scale') {
      <label class="app-field audit-execution-answer__number-field">
        <span class="app-field__label">{{ i18n.t('auditExecution.answers.value') }}</span>
        <input
          type="number"
          [min]="getMinimum()"
          [max]="getMaximum()"
          [value]="numericValue() ?? ''"
          [readOnly]="readOnly()"
          (input)="changeNumericValue($any($event.target).value)"
        />
      </label>
      <div class="audit-execution-answer__hint">
        {{ i18n.t('auditExecution.answers.range') }}: {{ getMinimum() }}–{{ getMaximum() }}
      </div>
    }
    @case ('number') {
      <label class="app-field audit-execution-answer__number-field">
        <span class="app-field__label">{{ i18n.t('auditExecution.answers.value') }}</span>
        <input
          type="number"
          [min]="getMinimum()"
          [max]="getMaximum()"
          [value]="numericValue() ?? ''"
          [readOnly]="readOnly()"
          (input)="changeNumericValue($any($event.target).value)"
        />
      </label>
      <div class="audit-execution-answer__hint">
        {{ i18n.t('auditExecution.answers.range') }}: {{ getMinimum() }}–{{ getMaximum() }}
      </div>
    }
    @case ('number_with_unit') {
      <div class="audit-execution-answer__number-with-unit">
        <label class="app-field audit-execution-answer__number-field">
          <span class="app-field__label">{{ i18n.t('auditExecution.answers.value') }}</span>
          <input
            type="number"
            [value]="numericValue() ?? ''"
            [readOnly]="readOnly()"
            (input)="changeNumericValue($any($event.target).value)"
          />
        </label>
        <span class="audit-execution-answer__unit">{{ getUnit() }}</span>
      </div>
    }
    @case ('multiscale') {
      <div class="audit-execution-answer__choice-grid">
        @for (option of getOptions(); track option.optionID) {
          <button
            class="audit-execution-answer__choice"
            [class.audit-execution-answer__choice--selected]="
              selectedOptionId() === option.optionID
            "
            type="button"
            [disabled]="readOnly()"
            [attr.aria-pressed]="selectedOptionId() === option.optionID"
            (click)="selectOption(option.optionID)"
          >
            {{ option.title }}
          </button>
        }
      </div>
    }
    @case ('multi_select') {
      <div class="audit-execution-answer__choice-grid">
        @for (option of getOptions(); track option.optionID) {
          <label
            class="audit-execution-answer__choice audit-execution-answer__choice--checkbox"
            [class.audit-execution-answer__choice--selected]="isOptionSelected(option.optionID)"
          >
            <input
              type="checkbox"
              [checked]="isOptionSelected(option.optionID)"
              [disabled]="readOnly()"
              (change)="toggleOption(option.optionID, $any($event.target).checked)"
            />
            <span>{{ option.title }}</span>
          </label>
        }
      </div>
    }
    @case ('text') {
      <label class="app-field">
        <span class="app-field__label">{{ i18n.t('auditExecution.answers.answer') }}</span>
        <textarea
          class="app-textarea"
          rows="3"
          [value]="textValue()"
          [readOnly]="readOnly()"
          (input)="changeTextValue($any($event.target).value)"
        ></textarea>
      </label>
    }
  }

  <label class="app-field audit-execution-answer__comment">
    <span class="app-field__label">{{ i18n.t('auditExecution.answers.comment') }}</span>
    <textarea
      class="app-textarea"
      rows="2"
      [value]="comment()"
      [readOnly]="readOnly()"
      (input)="changeComment($any($event.target).value)"
    ></textarea>
  </label>

  @if (item().allow_photo) {
    <section
      class="audit-execution-attachments"
      [attr.aria-label]="i18n.t('auditExecution.attachments.title')"
    >
      <div class="audit-execution-attachments__header">
        <div>
          <h6>{{ i18n.t('auditExecution.attachments.title') }}</h6>
          <p>{{ i18n.t('auditExecution.attachments.hint') }}</p>
        </div>
        @if (!readOnly()) { <label
          class="secondary-button secondary-button--compact audit-execution-attachments__upload"
          [class.audit-execution-attachments__upload--disabled]="isUploadingAttachment()"
        >
          <input
            type="file"
            accept=".jpg,.jpeg,.png,.webp,.heic,.heif,image/jpeg,image/png,image/webp,image/heic,image/heif"
            [disabled]="isUploadingAttachment()"
            (change)="handleAttachmentSelection($event)"
          />
          <span
            [class]="isUploadingAttachment() ? 'fa-solid fa-spinner fa-spin' : 'fa-solid fa-camera'"
            aria-hidden="true"
          ></span>
          {{
            i18n.t(
              isUploadingAttachment()
                ? 'auditExecution.attachments.uploading'
                : 'auditExecution.attachments.add'
            )
          }}
        </label> }
      </div>

      @if (attachments().length) {
        <ul class="audit-execution-attachments__list">
          @for (attachment of attachments(); track attachment.id) {
            <li class="audit-execution-attachments__item">
              <span class="fa-regular fa-image" aria-hidden="true"></span>
              <span class="audit-execution-attachments__file">
                <strong>{{ attachment.original_name }}</strong>
                <small>{{ formatAttachmentSize(attachment.size) }}</small>
              </span>
              @if (!readOnly()) { <button
                class="app-button--danger secondary-button secondary-button--compact audit-execution-attachments__delete"
                type="button"
                [disabled]="isAttachmentPendingDeletion(attachment.id)"
                [attr.aria-label]="
                  i18n.t('auditExecution.attachments.delete') + ': ' + attachment.original_name
                "
                (click)="deleteAttachment(attachment.id)"
              >
                <span
                  [class]="
                    isAttachmentPendingDeletion(attachment.id)
                      ? 'fa-solid fa-spinner fa-spin'
                      : 'fa-solid fa-trash-can'
                  "
                  aria-hidden="true"
                ></span>
              </button> }
            </li>
          }
        </ul>
      }

      @if (attachmentError()) {
        <div class="form-message audit-execution-attachments__error" role="alert"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span>
          {{ attachmentError() }}
        </div>
      }
    </section>
  }

  @if (!readOnly()) { <div class="audit-execution-answer__save-status" aria-live="polite">
    @switch (saveState()) {
      @case ('pending') {
        <span class="audit-execution-answer__status audit-execution-answer__status--pending">
          <span class="fa-solid fa-spinner fa-spin" aria-hidden="true"></span>
          {{ i18n.t('auditExecution.answers.saving') }}
        </span>
      }
      @case ('saved') {
        <span class="audit-execution-answer__status audit-execution-answer__status--saved">
          <span class="fa-solid fa-cloud-arrow-up" aria-hidden="true"></span>
          {{ i18n.t('auditExecution.answers.saved') }}
        </span>
      }
      @case ('error') {
        <div class="audit-execution-answer__save-error">
          <span class="form-message"><span class="app-message__icon app-message__icon--error fa-solid fa-circle-exclamation" aria-hidden="true"></span> {{ saveError() }}</span>
          <button
            class="secondary-button secondary-button--compact"
            type="button"
            (click)="retrySave()"
          >
            {{ i18n.t('auditExecution.actions.retry') }}
          </button>
        </div>
      }
    }
  </div> }
</div>
